import { render, staticRenderFns } from "./customerArchives.vue?vue&type=template&id=1fb90de6&scoped=true"
import script from "./customerArchives.vue?vue&type=script&lang=js"
export * from "./customerArchives.vue?vue&type=script&lang=js"
import style0 from "./customerArchives.vue?vue&type=style&index=0&id=1fb90de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb90de6",
  null
  
)

export default component.exports